
import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { ServiceResponse, UUID } from '@dopomogai/types';
import type { McpServerItem, McpTestRequest, McpTestResult } from '@dopomogai/types';

export const mcpService = {
  listServers: (agentId: UUID): ServiceResponse<McpServerItem[]> => {
    return getApiClient()
      .get<McpServerItem[]>(`/agents/${agentId}/mcp/servers`)
      .then(r => r.data)
      .catch(err => handleApiError(err, 'listing MCP servers'));
  },

  testServer: (agentId: UUID, serverId: string): ServiceResponse<McpTestResult> => {
    const body: McpTestRequest = { server_id: serverId };
    return getApiClient()
      .post<McpTestResult>(`/agents/${agentId}/mcp/test`, body)
      .then(r => r.data)
      .catch(err => handleApiError(err, `testing MCP server ${serverId}`));
  },
};